import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsLeafletComponent } from './simple-icons-leaflet.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsLeafletComponent ],
    exports:      [ SimpleIconsLeafletComponent ],
    bootstrap:    []
})
export class SimpleIconsLeafletModule {}
